import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, Printer } from "lucide-react";
import api, { formatApiError } from "../lib/api";
import { ReceiptDocument } from "../components/ReceiptDocument";
import { ReceiptTerms } from "../components/ReceiptTerms";
import { EmailReceiptButton } from "../components/admin/EmailReceiptButton";

export default function ReceiptPrint() {
  const { id } = useParams();
  const [receipt, setReceipt] = useState(null);
  const [error, setError] = useState("");
  const [copy, setCopy] = useState("customer");

  useEffect(() => {
    api.get(`/receipts/${id}`).then((r) => setReceipt(r.data)).catch((e) => setError(formatApiError(e)));
  }, [id]);

  return (
    <div className="min-h-screen bg-[#F1F5F9] py-8 px-4 print:bg-white print:p-0" data-testid="receipt-print-page">
      <div className="no-print max-w-[816px] mx-auto mb-4 flex flex-wrap gap-3 justify-between items-center">
        <Link to="/admin" className="inline-flex items-center gap-2 text-sm text-[#1E2A78] hover:underline" data-testid="receipt-print-back"><ArrowLeft className="h-4 w-4" /> Back to dashboard</Link>
        <div className="inline-flex border border-slate-300 rounded-sm overflow-hidden text-xs font-semibold" data-testid="receipt-copy-toggle">
          {[["customer", "Customer copy (yellow)"], ["office", "Office copy (white)"]].map(([k, l]) => (
            <button key={k} onClick={() => setCopy(k)} className={`px-3 py-2 ${copy === k ? "bg-[#1E2A78] text-white" : "bg-white text-slate-600"}`} data-testid={`receipt-copy-${k}`}>{l}</button>
          ))}
        </div>
        {receipt && !receipt.voided && <EmailReceiptButton receipt={receipt} copy={copy} onSent={(d) => setReceipt({ ...receipt, ...d })} className="px-4 py-2 bg-[#1E2A78] text-white font-semibold rounded-sm hover:bg-[#17205E] text-sm" />}
        <button onClick={() => window.print()} disabled={!receipt} className="px-4 py-2 bg-[#FFD700] text-[#1E2A78] font-semibold rounded-sm hover:bg-[#E6C200] inline-flex items-center gap-2 text-sm disabled:opacity-50" data-testid="receipt-print-btn">
          <Printer className="h-4 w-4" /> Print / Save PDF
        </button>
      </div>
      {error && <div className="text-center text-red-600" data-testid="receipt-print-error">{error}</div>}
      {!receipt && !error && <div className="text-center text-slate-500">Loading receipt...</div>}
      {receipt && (
        <>
          <ReceiptDocument r={receipt} copy={copy} />
          <div className="no-print h-8" />
          <div className="print-page-break"><ReceiptTerms copy={copy} /></div>
        </>
      )}
    </div>
  );
}
